// Monthly running costs of the home, as published in the donation details copy.
export const monthlyExpenseTotal = 74000;

export const monthlyExpenses = [
    { key: "rent", labelKey: "expenseRent", amount: 6000, fixed: true, icon: "fa-house" },
    { key: "electricity", labelKey: "expenseElectricity", amount: 4700, fixed: true, icon: "fa-bolt" },
    { key: "water", labelKey: "expenseWater", amount: 1100, fixed: true, icon: "fa-droplet" },
    { key: "phone", labelKey: "expensePhone", amount: 500, fixed: true, icon: "fa-phone" },
    { key: "tuition", labelKey: "expenseTuition", amount: null, fixed: true, icon: "fa-graduation-cap" },
    { key: "others", labelKey: "expenseOthers", amount: null, fixed: false, icon: "fa-utensils" },
];

export const openingHours = { open: "10am", close: "6pm" };
